import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Comprehensive ResizeObserver error suppression for mobile compatibility
const suppressResizeObserverError = (error) => {
  return (
    error &&
    (
      (typeof error === 'string' && error.includes('ResizeObserver loop completed with undelivered notifications')) ||
      (error.message && error.message.includes('ResizeObserver loop completed with undelivered notifications')) ||
      (error.stack && error.stack.includes('ResizeObserver loop completed with undelivered notifications'))
    )
  );
};

// 1. Override console.error globally
const originalConsoleError = console.error;
console.error = (...args) => {
  if (suppressResizeObserverError(args[0])) {
    return; // Suppress this specific error
  }
  originalConsoleError.apply(console, args);
};

// 2. Override console.warn for related warnings
const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  if (suppressResizeObserverError(args[0])) {
    return; // Suppress this specific warning
  }
  originalConsoleWarn.apply(console, args);
};

// 3. Handle unhandled errors
window.addEventListener('error', (event) => {
  if (suppressResizeObserverError(event.error) || suppressResizeObserverError(event.message)) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
});

// 4. Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (suppressResizeObserverError(event.reason)) {
    event.preventDefault();
    return true;
  }
});

// 5. Override ResizeObserver entirely if needed for development
if (process.env.NODE_ENV === 'development') {
  const originalResizeObserver = window.ResizeObserver;
  let resizeObserverLoopErrRe = /^[^(ResizeObserver loop limit exceeded)]/;
  
  window.ResizeObserver = class extends originalResizeObserver {
    constructor(callback) {
      const wrappedCallback = (entries, observer) => {
        try {
          callback(entries, observer);
        } catch (error) {
          if (resizeObserverLoopErrRe.test(error.message)) {
            throw error;
          }
          // Silently ignore ResizeObserver loop errors
        }
      };
      super(wrappedCallback);
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
